import React, {useEffect, useState} from "react";
import {useRouter} from "next/router";
import ErrorPage from 'next/error'
import {bindActionCreators} from "redux";
import {setScrollPosition} from "../../screens/sidemenu/following/group_profile/GroupActions";
import {openModal} from "../../features/modals/modalActions";
import {
    getLikedPosts,
    getUserPosts,
    getUserProfile,
    resetUserPosts,
    updateProfilePic
} from "../../screens/sidemenu/profile/ProfileActions";
import {connect} from "react-redux";
import {initializeStore} from "../../config/store";
import PostList from "../../features/post/PostList";
import Image from "react-bootstrap/Image";
import {Icon, Tab} from "semantic-ui-react";
import LoadingComponent from "../../components/LoadingComponent";
import {firestore} from "../../config/firebase";
import isEmpty from "lodash/isEmpty";
import {NextSeo} from "next-seo";
import Layout from "../../features/nav/Layout";

import 'semantic-ui-css/components/tab.min.css'
import 'semantic-ui-css/components/menu.min.css'
import {collection, doc, getDoc} from "firebase/firestore/lite";
import {useUser} from "../../context/userContext";
import {Button} from "react-bootstrap";

const User = props => {
    const {userId: currentUserId} = useUser();

    useEffect(() => {

        window.scrollTo(0, props.scrollPosition);

        return () => {
            props.setScrollPosition(window.scrollY);
        };
    }, [])


    const router = useRouter()

    if (!router.isFallback && !props.profile?.username) {
        return (
            <Layout mainContent={
                <ErrorPage statusCode={404}/>
            }/>
        )
    }

    const [profilePic, setProfilePic] = useState(props.profile?.photoURL);

    if (isEmpty(props.profile)) return <LoadingComponent/>

    let {ftc, overallPosition, points, username, gender, bio, photoURL, followersCnt, followingCnt} = props.profile;
    photoURL = photoURL || "https://eu.ui-avatars.com/api/?name=".concat(username, '&size=134', '&background=008B4B', '&color=fff')
    const description = "Keep up with Nigerian trends, breaking news, local news, fashion, weddings, viral video clips and funny jokes. NaijaWorld is open for everyone to post, share, vote and discuss";
    const metaImage = "https://eu.ui-avatars.com/api/?name=".concat(username, '&background=008B4B', '&color=fff');
    const metaUrl = 'https://naijaworld.online/u/'.concat(props.userId);
    const title = username.concat('\'s profile on NaijaWorld');


    let isCurrentUser = props.userId === currentUserId;


    const panes = [
        {
            menuItem: 'Posts', render: () =>
                // <Tab.Pane>
                <PostList
                    posts={props.userPosts}
                    getNextPosts={props.getUserPosts.bind(null, false, props.userId)}
                    loading={props.loading}
                    hasMore={props.hasMoreUserPosts}
                    emptyMessage={"No post yet"}
                />
            // </Tab.Pane>
        },
        {
            menuItem: 'Likes', render: () =>
                // <Tab.Pane>
                <PostList
                    posts={props.likedPosts}
                    getNextPosts={props.getLikedPosts.bind(null, false, props.userId)}
                    loading={props.loading}
                    hasMore={props.hasMoreLikedPosts}
                    emptyMessage={"No liked posts"}
                />
            // </Tab.Pane>
        }
    ];

    const handleImageChange = (event) => {
        const imageFile = event.target.files[0]
        setProfilePic(URL.createObjectURL(imageFile))
        props.updateProfilePic(imageFile)
    };

    return (
        <div>
            <NextSeo
                title={title}
                description={description}
                // canonical={metaUrl}
                openGraph={{
                    url: metaUrl,
                    title: title,
                    description: description,
                    images: [
                        {url: metaImage, alt: title}
                    ],
                }}
            />
            <Layout mainContent={
                <div>
                    <div className={'py-4  px-2'}>
                        {isCurrentUser ?
                            <div className={"d-flex justify-content-between"}>
                                <div className={'d-flex flex-column pb-0'}>
                                    <label htmlFor="avatar">
                                        <input type="file"
                                               id="avatar" name="avatar"
                                               accept="image/png,  image/jpeg" className={'d-none'}
                                               onChange={handleImageChange}
                                        />
                                        <Image
                                            src={profilePic || photoURL}
                                            roundedCircle
                                            rounded
                                            width={135}
                                            height={135}
                                        />
                                        <div style={{
                                            position: 'relative',
                                            bottom: '40px',
                                            left: '100px'
                                        }}>
                                            <Icon name={'camera'} circular bordered color={"green"}
                                                  className={'bg-white'}/>
                                        </div>
                                    </label>
                                </div>
                                <Button variant="outline-success" className={"align-self-end"}
                                        onClick={() => props.openModal('EditProfileModal')}>
                                    Edit Profile
                                </Button>
                            </div> :
                            <div className={"d-flex justify-content-between"}>
                                <Image
                                    src={profilePic || photoURL}
                                    roundedCircle
                                    rounded
                                    width={135}
                                    height={135}
                                />
                                {/*<div className={"d-flex flex-column justify-content-center"}>*/}
                                {/*    <div className={'d-flex flex-row border-bottom'}>*/}
                                {/*        <div className={'pr-3'}>*/}
                                {/*            <h1 className={'text-center mb-0'}>{followersCnt || 0}</h1>*/}
                                {/*            <div>Followers</div>*/}
                                {/*        </div>*/}
                                {/*        <div>*/}
                                {/*            <h1 className={'text-center mb-0'}>{followingCnt || 0}</h1>*/}
                                {/*            <div>Following</div>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*    <Button variant="outline-success" className={"align-self-end w-100 mt-2"}*/}
                                {/*        // onClick={() => props.openModal('FollowUserModal')}>*/}
                                {/*            onClick={() => console.log('FollowUserModal')}>*/}
                                {/*        Follow*/}
                                {/*    </Button>*/}
                                {/*</div>*/}
                            </div>
                        }
                        <div className={"pl-2"}>
                            <h3>
                                {username}
                            </h3>
                            {bio}
                        </div>
                    </div>
                    <Tab panes={panes}
                         menu={{attached: true, secondary: false, pointing: true, className: 'two item'}}
                         onTabChange={(e, {activeIndex}) => {
                             switch (activeIndex) {
                                 case 1:
                                     props.getLikedPosts(true, props.userId);
                                     break;
                             }
                         }}
                    />
                </div>
            }/>
        </div>

    )
}

export async function getStaticPaths() {

    return {
        paths: [{
            params: {
                id: 'YTESekNmexY0Tgs3sI9CHm5ArVy1'
            }
        }],
        fallback: true
    };
}


export async function getStaticProps({params}) {

    const userId = params.id
    const reduxStore = initializeStore()
    const {dispatch} = reduxStore

    await dispatch(getUserPosts(true, userId))
    const userRef = doc(collection(firestore, 'users'), userId);
    let snapshot = await getDoc(userRef)
    let profile = snapshot.data() || {}
    if (!isEmpty(profile)) {
        if (profile['dob']) {
            profile['dob'] = profile['dob']?.toMillis()
        }
        profile.hasOwnProperty('createdAt') ? profile['createdAt'] = profile['createdAt'].toMillis() : null
        profile.hasOwnProperty('dateOfBirth') ? profile['dateOfBirth'] = profile['dateOfBirth'].toMillis() : null
    }

    return {
        props: {
            userId,
            profile,
            initialReduxState: reduxStore.getState()
        },
        revalidate: 1800
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        userPosts: Object.values(state.posts).filter(post => post.authorId === ownProps.userId).sort((a, b) => b.timeStamp - a.timeStamp),
        likedPosts: Object.values(state.posts).filter(post => post.likers.includes(ownProps.userId)),
        hasMoreLikedPosts: state.profile.hasMoreLikedPosts,
        hasMoreUserPosts: state.profile.hasMoreUserPosts,
        loading: state.async.loading,
        scrollPosition: state.profile.scrollPosition
    };

};

const mapDispatchToProps = dispatch => {
    return {
        getUserPosts: bindActionCreators(getUserPosts, dispatch),
        getLikedPosts: bindActionCreators(getLikedPosts, dispatch),
        resetUserPosts: bindActionCreators(resetUserPosts, dispatch),
        setScrollPosition: bindActionCreators(setScrollPosition, dispatch),
        openModal: bindActionCreators(openModal, dispatch),
        getUserProfile: bindActionCreators(getUserProfile, dispatch),
        updateProfilePic: bindActionCreators(updateProfilePic, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(User);